import { useState, useEffect } from "react";
import { Bell, Mail, MessageSquare, AlertCircle } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("dd_token")}` } });

const TYPE_META = {
  quote_submitted: { icon: Bell, color: "#3B82F6", label: "Quote Submitted" },
  status_change: { icon: AlertCircle, color: "#F59E0B", label: "Status Change" },
  invoice_sent: { icon: Mail, color: "#16A34A", label: "Invoice Sent" },
  payment_received: { icon: Mail, color: "#16A34A", label: "Payment Received" },
};

export default function NotificationCenter() {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/notifications`, auth());
        setNotifications(res.data);
      } catch { /* ok */ }
    })();
  }, []);

  return (
    <div className="p-6 sm:p-8" data-testid="notification-center">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-[#F8FAFC] font-black text-2xl tracking-tighter">Notification Center</h1>
        <div className="bg-[#D95D39]/10 border border-[#D95D39]/30 text-[#D95D39] text-xs font-bold px-3 py-1.5 rounded-sm">
          MOCKED — Ready for Twilio/SendGrid
        </div>
      </div>

      <div className="border border-[#1F2937] rounded-sm bg-[#0F1A15] p-5 mb-6">
        <p className="text-[#9CA3AF] text-sm leading-relaxed">
          Notifications are currently <span className="text-[#F59E0B] font-semibold">mocked</span>. All events are logged here. When you're ready to go live, drop in your Twilio (SMS) and SendGrid (email) API keys for real delivery.
        </p>
      </div>

      {notifications.length === 0 ? (
        <div className="text-center py-16 text-[#64748B]">
          <Bell className="w-10 h-10 mx-auto mb-3 opacity-30" />
          <p className="text-sm">No notifications yet</p>
          <p className="text-xs mt-1">Notifications appear when quotes are submitted or job statuses change</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="notification-list">
          {notifications.map((n) => {
            const meta = TYPE_META[n.type] || TYPE_META.quote_submitted;
            const Icon = meta.icon;
            return (
              <div key={n.id} className="border border-[#1F2937] rounded-sm p-4 bg-[#0B110E] flex items-start gap-3" data-testid={`notification-${n.id}`}>
                <div className="w-8 h-8 rounded-sm flex items-center justify-center shrink-0" style={{ backgroundColor: meta.color + "15" }}>
                  <Icon className="w-4 h-4" style={{ color: meta.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className="text-xs font-bold uppercase tracking-wider" style={{ color: meta.color }}>{meta.label}</span>
                    <span className="text-[#374151] text-xs">|</span>
                    <span className="text-[#64748B] text-xs flex items-center gap-1">
                      {n.channel === "sms" ? <MessageSquare className="w-3 h-3" /> : <Mail className="w-3 h-3" />}
                      {n.channel.toUpperCase()} to {n.recipient}
                    </span>
                  </div>
                  <p className="text-[#F8FAFC] text-sm">{n.message}</p>
                  <p className="text-[#374151] text-xs mt-1">{new Date(n.created_at).toLocaleString()} — <span className="text-[#F59E0B]">{n.status}</span></p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
